import Vue from 'vue';
import TrackingService from '@animaapp/anima-tracking';
import store from '@/store';
import { addDebugEvent } from '@/services/bus';
import errorHandler from '@/services/errorHandler';

const config = {
  web: true,
  clientId: 'com.animaapp.web',
  baseURL: process.env.TRACKING_BASE_URL
};

/*
 * Ungated: every method dispatches whatever the visitor answered on the cookie
 * banner, including alias(), which POSTs the user id and the visitor id to
 * /analytics/register_alias.
 *
 * This is a product decision about our own collector, and a wider one than
 * Google Consent Mode advanced in public/index.html - Google gets cookieless
 * pings with no identifiers, this endpoint gets the identifiers. Anyone
 * revisiting it should start there rather than here.
 */
export const tracking = new TrackingService(config);
export const trackEvent = (eventName, params = {}) => {
  if (!eventName) {
    return;
  } else if (localStorage.getItem('animp')) {
    // if impersonating - don't track
    return;
  }

  const extraTrackingData = store.getters['tracking/extraData'];
  const isChromeExtension = store.state.omniview?.isChromeExtension;

  if (isChromeExtension) {
    let extensionName = store.state['omniview'].extensionName;

    // add this flag so we can detect if this event is coming from the chrome extension or not
    params.extensionName = extensionName;
    params.fromChromeExtension = true;
  }
  try {
    tracking.trackEvent(eventName, { ...extraTrackingData, ...params });
    Vue.prototype?.$hj && Vue.prototype?.$hj('event', eventName);
  } catch (err) {
    errorHandler.captureException(err);
  }

  addDebugEvent({ eventName, params: { ...extraTrackingData, ...params } });
};

export const trackUserProps = (props) => {
  // Impersonated sessions are still excluded - that check is about not
  // attributing staff activity to a customer, and has nothing to do with consent.
  if (localStorage.getItem('animp')) {
    return;
  }

  try {
    tracking.setUserProperties(props);
  } catch (err) {
    errorHandler.captureException(err);
  }
};

export const debugEvent = (eventName, params = {}) => {
  const extraTrackingData = store.getters['tracking/extraData'];
  addDebugEvent({ eventName, params: { ...extraTrackingData, ...params } });
};

// remove timeout until refactor for better measuring
export const measure = (label) => tracking.measureStart(`web-app.${label}`);
export const measureEnd = (label, props) => tracking.measureEnd(`web-app.${label}`, props);
